import styled from 'styled-components';
import { Color } from '../../config/Color';
import { BodySM } from './Typography';

export const BaseErrorMessage = styled.div`
  color: ${Color.state.error};
  border-radius: 0.5em;
  padding-top: 0.5em;
  padding-bottom: 0.25em;
  margin-bottom: 0.75em;
`;

export const ErrorMessage = styled(BaseErrorMessage)`
  background-color: ${Color.surface.muted};
  border: 2px solid ${Color.state.error};
`;

export const ErrorText = styled(BodySM)`
  color: ${Color.state.error};
  margin: 1em;
`;
